"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: feature-store/user-features.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ffeature-store%2Fuser-features.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralFeatures = exports.IdentityCheckFeatures = exports.UserGraphFeatures = exports.ZipcodeFeatures = exports.LendingFeatures = exports.IssuingFeatures = exports.FundingFeatures = exports.FamilyFeatures = exports.UserFeatures = exports.UserLevelFeatures = void 0;
const family_group_1 = require("../common/family-group");
const kyc_1 = require("../common/kyc");
const device_features_1 = require("../graph/device-features");
const external_account_features_1 = require("../graph/external-account-features");
const identity_check_1 = require("../identity/identity-check");
const protobufPackage = 'com.step.featurestore.internal.proto';
function createBaseUserLevelFeatures() {
    return {
        userId: '',
        user: exports.UserFeatures.fromPartial({}),
        family: exports.FamilyFeatures.fromPartial({}),
        identityCheck: undefined,
        familyOwnerIdentityCheck: undefined,
        device: undefined,
        isFamilyOwnerSponsor: false,
        externalAccount: undefined,
        funding: undefined,
        issuing: undefined,
        lending: undefined,
        kycZipcode: undefined,
        shippingZipcode: undefined,
        userGraph: undefined,
    };
}
exports.UserLevelFeatures = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            user: isSet(object.user) ? exports.UserFeatures.fromJSON(object.user) : exports.UserFeatures.fromPartial({}),
            family: isSet(object.family)
                ? exports.FamilyFeatures.fromJSON(object.family)
                : exports.FamilyFeatures.fromPartial({}),
        };
        if (isSet(object.identityCheck)) {
            message.identityCheck = exports.IdentityCheckFeatures.fromJSON(object.identityCheck);
        }
        if (isSet(object.familyOwnerIdentityCheck)) {
            message.familyOwnerIdentityCheck = exports.IdentityCheckFeatures.fromJSON(object.familyOwnerIdentityCheck);
        }
        if (isSet(object.device)) {
            message.device = device_features_1.DeviceFeatures.fromJSON(object.device);
        }
        if (isSet(object.isFamilyOwnerSponsor)) {
            message.isFamilyOwnerSponsor = globalThis.Boolean(object.isFamilyOwnerSponsor);
        }
        if (isSet(object.externalAccount)) {
            message.externalAccount = external_account_features_1.ExternalAccountFeatures.fromJSON(object.externalAccount);
        }
        if (isSet(object.funding)) {
            message.funding = exports.FundingFeatures.fromJSON(object.funding);
        }
        if (isSet(object.issuing)) {
            message.issuing = exports.IssuingFeatures.fromJSON(object.issuing);
        }
        if (isSet(object.lending)) {
            message.lending = exports.LendingFeatures.fromJSON(object.lending);
        }
        if (isSet(object.kycZipcode)) {
            message.kycZipcode = exports.ZipcodeFeatures.fromJSON(object.kycZipcode);
        }
        if (isSet(object.shippingZipcode)) {
            message.shippingZipcode = exports.ZipcodeFeatures.fromJSON(object.shippingZipcode);
        }
        if (isSet(object.userGraph)) {
            message.userGraph = exports.UserGraphFeatures.fromJSON(object.userGraph);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.user !== undefined) {
            obj.user = exports.UserFeatures.toJSON(message.user);
        }
        if (message.family !== undefined) {
            obj.family = exports.FamilyFeatures.toJSON(message.family);
        }
        if (message.identityCheck !== undefined) {
            obj.identityCheck = exports.IdentityCheckFeatures.toJSON(message.identityCheck);
        }
        if (message.familyOwnerIdentityCheck !== undefined) {
            obj.familyOwnerIdentityCheck = exports.IdentityCheckFeatures.toJSON(message.familyOwnerIdentityCheck);
        }
        if (message.device !== undefined) {
            obj.device = device_features_1.DeviceFeatures.toJSON(message.device);
        }
        if (message.isFamilyOwnerSponsor !== undefined && message.isFamilyOwnerSponsor !== false) {
            obj.isFamilyOwnerSponsor = message.isFamilyOwnerSponsor;
        }
        if (message.externalAccount !== undefined) {
            obj.externalAccount = external_account_features_1.ExternalAccountFeatures.toJSON(message.externalAccount);
        }
        if (message.funding !== undefined) {
            obj.funding = exports.FundingFeatures.toJSON(message.funding);
        }
        if (message.issuing !== undefined) {
            obj.issuing = exports.IssuingFeatures.toJSON(message.issuing);
        }
        if (message.lending !== undefined) {
            obj.lending = exports.LendingFeatures.toJSON(message.lending);
        }
        if (message.kycZipcode !== undefined) {
            obj.kycZipcode = exports.ZipcodeFeatures.toJSON(message.kycZipcode);
        }
        if (message.shippingZipcode !== undefined) {
            obj.shippingZipcode = exports.ZipcodeFeatures.toJSON(message.shippingZipcode);
        }
        if (message.userGraph !== undefined) {
            obj.userGraph = exports.UserGraphFeatures.toJSON(message.userGraph);
        }
        return obj;
    },
    create(base) {
        return exports.UserLevelFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserLevelFeatures();
        message.userId = object.userId ?? '';
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.UserFeatures.fromPartial(object.user)
            : exports.UserFeatures.fromPartial({});
        message.family = (object.family !== undefined && object.family !== null)
            ? exports.FamilyFeatures.fromPartial(object.family)
            : exports.FamilyFeatures.fromPartial({});
        message.identityCheck = (object.identityCheck !== undefined && object.identityCheck !== null)
            ? exports.IdentityCheckFeatures.fromPartial(object.identityCheck)
            : undefined;
        message.familyOwnerIdentityCheck =
            (object.familyOwnerIdentityCheck !== undefined && object.familyOwnerIdentityCheck !== null)
                ? exports.IdentityCheckFeatures.fromPartial(object.familyOwnerIdentityCheck)
                : undefined;
        message.device = (object.device !== undefined && object.device !== null)
            ? device_features_1.DeviceFeatures.fromPartial(object.device)
            : undefined;
        message.isFamilyOwnerSponsor = object.isFamilyOwnerSponsor ?? false;
        message.externalAccount =
            (object.externalAccount !== undefined && object.externalAccount !== null)
                ? external_account_features_1.ExternalAccountFeatures.fromPartial(object.externalAccount)
                : undefined;
        message.funding = (object.funding !== undefined && object.funding !== null)
            ? exports.FundingFeatures.fromPartial(object.funding)
            : undefined;
        message.issuing = (object.issuing !== undefined && object.issuing !== null)
            ? exports.IssuingFeatures.fromPartial(object.issuing)
            : undefined;
        message.lending = (object.lending !== undefined && object.lending !== null)
            ? exports.LendingFeatures.fromPartial(object.lending)
            : undefined;
        message.kycZipcode = (object.kycZipcode !== undefined && object.kycZipcode !== null)
            ? exports.ZipcodeFeatures.fromPartial(object.kycZipcode)
            : undefined;
        message.shippingZipcode =
            (object.shippingZipcode !== undefined && object.shippingZipcode !== null)
                ? exports.ZipcodeFeatures.fromPartial(object.shippingZipcode)
                : undefined;
        message.userGraph = (object.userGraph !== undefined && object.userGraph !== null)
            ? exports.UserGraphFeatures.fromPartial(object.userGraph)
            : undefined;
        return message;
    },
};
function createBaseUserFeatures() {
    return {
        userId: '',
        createdAtMs: '0',
        updatedAtMs: '0',
        userCreatedAtMs: '0',
        kycStatus: kyc_1.KycStatus.INVALID,
        kycZipcode: '',
        shippingZipcode: '',
        tenureDays: 0,
        dob: '',
    };
}
exports.UserFeatures = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
            userCreatedAtMs: isSet(object.userCreatedAtMs)
                ? globalThis.String(object.userCreatedAtMs)
                : '0',
            kycStatus: isSet(object.kycStatus) ? (0, kyc_1.kycStatusFromJSON)(object.kycStatus) : kyc_1.KycStatus.INVALID,
        };
        if (isSet(object.kycZipcode)) {
            message.kycZipcode = globalThis.String(object.kycZipcode);
        }
        if (isSet(object.shippingZipcode)) {
            message.shippingZipcode = globalThis.String(object.shippingZipcode);
        }
        if (isSet(object.tenureDays)) {
            message.tenureDays = globalThis.Number(object.tenureDays);
        }
        if (isSet(object.dob)) {
            message.dob = globalThis.String(object.dob);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.userCreatedAtMs !== '0') {
            obj.userCreatedAtMs = message.userCreatedAtMs;
        }
        if (message.kycStatus !== kyc_1.KycStatus.INVALID) {
            obj.kycStatus = (0, kyc_1.kycStatusToJSON)(message.kycStatus);
        }
        if (message.kycZipcode !== undefined && message.kycZipcode !== '') {
            obj.kycZipcode = message.kycZipcode;
        }
        if (message.shippingZipcode !== undefined && message.shippingZipcode !== '') {
            obj.shippingZipcode = message.shippingZipcode;
        }
        if (message.tenureDays !== undefined && message.tenureDays !== 0) {
            obj.tenureDays = Math.round(message.tenureDays);
        }
        if (message.dob !== undefined && message.dob !== '') {
            obj.dob = message.dob;
        }
        return obj;
    },
    create(base) {
        return exports.UserFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserFeatures();
        message.userId = object.userId ?? '';
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.userCreatedAtMs = object.userCreatedAtMs ?? '0';
        message.kycStatus = object.kycStatus ?? kyc_1.KycStatus.INVALID;
        message.kycZipcode = object.kycZipcode ?? '';
        message.shippingZipcode = object.shippingZipcode ?? '';
        message.tenureDays = object.tenureDays ?? 0;
        message.dob = object.dob ?? '';
        return message;
    },
};
function createBaseFamilyFeatures() {
    return {
        familyId: '',
        userId: '',
        joinedAtMs: '0',
        group: family_group_1.FamilyGroup.FAMILY_INVALID,
        isOwner: false,
        isSponsor: false,
        isSponsee: false,
        isCoSponsor: false,
        size: 0,
        createdAtMs: '0',
        updatedAtMs: '0',
    };
}
exports.FamilyFeatures = {
    fromJSON(object) {
        const message = {
            familyId: isSet(object.familyId) ? globalThis.String(object.familyId) : '',
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            joinedAtMs: isSet(object.joinedAtMs) ? globalThis.String(object.joinedAtMs) : '0',
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.group)) {
            message.group = (0, family_group_1.familyGroupFromJSON)(object.group);
        }
        if (isSet(object.isOwner)) {
            message.isOwner = globalThis.Boolean(object.isOwner);
        }
        if (isSet(object.isSponsor)) {
            message.isSponsor = globalThis.Boolean(object.isSponsor);
        }
        if (isSet(object.isSponsee)) {
            message.isSponsee = globalThis.Boolean(object.isSponsee);
        }
        if (isSet(object.isCoSponsor)) {
            message.isCoSponsor = globalThis.Boolean(object.isCoSponsor);
        }
        if (isSet(object.size)) {
            message.size = globalThis.Number(object.size);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyId !== '') {
            obj.familyId = message.familyId;
        }
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.joinedAtMs !== '0') {
            obj.joinedAtMs = message.joinedAtMs;
        }
        if (message.group !== undefined && message.group !== family_group_1.FamilyGroup.FAMILY_INVALID) {
            obj.group = (0, family_group_1.familyGroupToJSON)(message.group);
        }
        if (message.isOwner !== undefined && message.isOwner !== false) {
            obj.isOwner = message.isOwner;
        }
        if (message.isSponsor !== undefined && message.isSponsor !== false) {
            obj.isSponsor = message.isSponsor;
        }
        if (message.isSponsee !== undefined && message.isSponsee !== false) {
            obj.isSponsee = message.isSponsee;
        }
        if (message.isCoSponsor !== undefined && message.isCoSponsor !== false) {
            obj.isCoSponsor = message.isCoSponsor;
        }
        if (message.size !== undefined && message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.FamilyFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFamilyFeatures();
        message.familyId = object.familyId ?? '';
        message.userId = object.userId ?? '';
        message.joinedAtMs = object.joinedAtMs ?? '0';
        message.group = object.group ?? family_group_1.FamilyGroup.FAMILY_INVALID;
        message.isOwner = object.isOwner ?? false;
        message.isSponsor = object.isSponsor ?? false;
        message.isSponsee = object.isSponsee ?? false;
        message.isCoSponsor = object.isCoSponsor ?? false;
        message.size = object.size ?? 0;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function createBaseFundingFeatures() {
    return {
        fundingCommittedCountPast: 0,
        fundingCommittedAmountValueSumPast: 0,
        ddTransactionCountPast: 0,
        ddTransactionCountL31d: 0,
        ddTransactionCountL45d: 0,
        ddAmountValueSumPast: 0,
        ddAmountValueSumL31d: 0,
        ddAmountValueSumL45d: 0,
    };
}
exports.FundingFeatures = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.fundingCommittedCountPast)) {
            message.fundingCommittedCountPast = globalThis.Number(object.fundingCommittedCountPast);
        }
        if (isSet(object.fundingCommittedAmountValueSumPast)) {
            message.fundingCommittedAmountValueSumPast = globalThis.Number(object.fundingCommittedAmountValueSumPast);
        }
        if (isSet(object.ddTransactionCountPast)) {
            message.ddTransactionCountPast = globalThis.Number(object.ddTransactionCountPast);
        }
        if (isSet(object.ddTransactionCountL31d)) {
            message.ddTransactionCountL31d = globalThis.Number(object.ddTransactionCountL31d);
        }
        if (isSet(object.ddTransactionCountL45d)) {
            message.ddTransactionCountL45d = globalThis.Number(object.ddTransactionCountL45d);
        }
        if (isSet(object.ddAmountValueSumPast)) {
            message.ddAmountValueSumPast = globalThis.Number(object.ddAmountValueSumPast);
        }
        if (isSet(object.ddAmountValueSumL31d)) {
            message.ddAmountValueSumL31d = globalThis.Number(object.ddAmountValueSumL31d);
        }
        if (isSet(object.ddAmountValueSumL45d)) {
            message.ddAmountValueSumL45d = globalThis.Number(object.ddAmountValueSumL45d);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fundingCommittedCountPast !== undefined && message.fundingCommittedCountPast !== 0) {
            obj.fundingCommittedCountPast = Math.round(message.fundingCommittedCountPast);
        }
        if (message.fundingCommittedAmountValueSumPast !== undefined &&
            message.fundingCommittedAmountValueSumPast !== 0) {
            obj.fundingCommittedAmountValueSumPast = message.fundingCommittedAmountValueSumPast;
        }
        if (message.ddTransactionCountPast !== undefined && message.ddTransactionCountPast !== 0) {
            obj.ddTransactionCountPast = Math.round(message.ddTransactionCountPast);
        }
        if (message.ddTransactionCountL31d !== undefined && message.ddTransactionCountL31d !== 0) {
            obj.ddTransactionCountL31d = Math.round(message.ddTransactionCountL31d);
        }
        if (message.ddTransactionCountL45d !== undefined && message.ddTransactionCountL45d !== 0) {
            obj.ddTransactionCountL45d = Math.round(message.ddTransactionCountL45d);
        }
        if (message.ddAmountValueSumPast !== undefined && message.ddAmountValueSumPast !== 0) {
            obj.ddAmountValueSumPast = message.ddAmountValueSumPast;
        }
        if (message.ddAmountValueSumL31d !== undefined && message.ddAmountValueSumL31d !== 0) {
            obj.ddAmountValueSumL31d = message.ddAmountValueSumL31d;
        }
        if (message.ddAmountValueSumL45d !== undefined && message.ddAmountValueSumL45d !== 0) {
            obj.ddAmountValueSumL45d = message.ddAmountValueSumL45d;
        }
        return obj;
    },
    create(base) {
        return exports.FundingFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingFeatures();
        message.fundingCommittedCountPast = object.fundingCommittedCountPast ?? 0;
        message.fundingCommittedAmountValueSumPast = object.fundingCommittedAmountValueSumPast ?? 0;
        message.ddTransactionCountPast = object.ddTransactionCountPast ?? 0;
        message.ddTransactionCountL31d = object.ddTransactionCountL31d ?? 0;
        message.ddTransactionCountL45d = object.ddTransactionCountL45d ?? 0;
        message.ddAmountValueSumPast = object.ddAmountValueSumPast ?? 0;
        message.ddAmountValueSumL31d = object.ddAmountValueSumL31d ?? 0;
        message.ddAmountValueSumL45d = object.ddAmountValueSumL45d ?? 0;
        return message;
    },
};
function createBaseIssuingFeatures() {
    return {
        cardPurchaseCountL7d: 0,
        cardPurchaseAmountValueSumL7d: 0,
        cardPurchaseCountL30d: 0,
        cardPurchaseAmountValueSumL30d: 0,
    };
}
exports.IssuingFeatures = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.cardPurchaseCountL7d)) {
            message.cardPurchaseCountL7d = globalThis.Number(object.cardPurchaseCountL7d);
        }
        if (isSet(object.cardPurchaseAmountValueSumL7d)) {
            message.cardPurchaseAmountValueSumL7d = globalThis.Number(object.cardPurchaseAmountValueSumL7d);
        }
        if (isSet(object.cardPurchaseCountL30d)) {
            message.cardPurchaseCountL30d = globalThis.Number(object.cardPurchaseCountL30d);
        }
        if (isSet(object.cardPurchaseAmountValueSumL30d)) {
            message.cardPurchaseAmountValueSumL30d = globalThis.Number(object.cardPurchaseAmountValueSumL30d);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardPurchaseCountL7d !== undefined && message.cardPurchaseCountL7d !== 0) {
            obj.cardPurchaseCountL7d = Math.round(message.cardPurchaseCountL7d);
        }
        if (message.cardPurchaseAmountValueSumL7d !== undefined &&
            message.cardPurchaseAmountValueSumL7d !== 0) {
            obj.cardPurchaseAmountValueSumL7d = message.cardPurchaseAmountValueSumL7d;
        }
        if (message.cardPurchaseCountL30d !== undefined && message.cardPurchaseCountL30d !== 0) {
            obj.cardPurchaseCountL30d = Math.round(message.cardPurchaseCountL30d);
        }
        if (message.cardPurchaseAmountValueSumL30d !== undefined &&
            message.cardPurchaseAmountValueSumL30d !== 0) {
            obj.cardPurchaseAmountValueSumL30d = message.cardPurchaseAmountValueSumL30d;
        }
        return obj;
    },
    create(base) {
        return exports.IssuingFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIssuingFeatures();
        message.cardPurchaseCountL7d = object.cardPurchaseCountL7d ?? 0;
        message.cardPurchaseAmountValueSumL7d = object.cardPurchaseAmountValueSumL7d ?? 0;
        message.cardPurchaseCountL30d = object.cardPurchaseCountL30d ?? 0;
        message.cardPurchaseAmountValueSumL30d = object.cardPurchaseAmountValueSumL30d ?? 0;
        return message;
    },
};
function createBaseLendingFeatures() {
    return {
        loansTakenCountPast: 0,
        loansFullyRepaidCountPast: 0,
        loansOutstandingCount: 0,
        loansDelinquentCount: 0,
        loansFullyRepaidPct: 0,
        loansDelinquentPct: 0,
        loanSizeAvgPast: 0,
        installmentsCountPast: 0,
        outstandingInstallmentsCountPast: 0,
        outstandingPrincipalSum: 0,
        installmentsDueCountPast: 0,
        dollarDelinquentInstallmentsSumPast: 0,
        delinquentInstallmentsCount: 0,
        dollarsPaidSumPast: 0,
        updatedAtMs: '0',
        lendingRiskLevel: '',
        paidLoanCountLevel: 0,
    };
}
exports.LendingFeatures = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.loansTakenCountPast)) {
            message.loansTakenCountPast = globalThis.Number(object.loansTakenCountPast);
        }
        if (isSet(object.loansFullyRepaidCountPast)) {
            message.loansFullyRepaidCountPast = globalThis.Number(object.loansFullyRepaidCountPast);
        }
        if (isSet(object.loansOutstandingCount)) {
            message.loansOutstandingCount = globalThis.Number(object.loansOutstandingCount);
        }
        if (isSet(object.loansDelinquentCount)) {
            message.loansDelinquentCount = globalThis.Number(object.loansDelinquentCount);
        }
        if (isSet(object.loansFullyRepaidPct)) {
            message.loansFullyRepaidPct = globalThis.Number(object.loansFullyRepaidPct);
        }
        if (isSet(object.loansDelinquentPct)) {
            message.loansDelinquentPct = globalThis.Number(object.loansDelinquentPct);
        }
        if (isSet(object.loanSizeAvgPast)) {
            message.loanSizeAvgPast = globalThis.Number(object.loanSizeAvgPast);
        }
        if (isSet(object.installmentsCountPast)) {
            message.installmentsCountPast = globalThis.Number(object.installmentsCountPast);
        }
        if (isSet(object.outstandingInstallmentsCountPast)) {
            message.outstandingInstallmentsCountPast = globalThis.Number(object.outstandingInstallmentsCountPast);
        }
        if (isSet(object.outstandingPrincipalSum)) {
            message.outstandingPrincipalSum = globalThis.Number(object.outstandingPrincipalSum);
        }
        if (isSet(object.installmentsDueCountPast)) {
            message.installmentsDueCountPast = globalThis.Number(object.installmentsDueCountPast);
        }
        if (isSet(object.dollarDelinquentInstallmentsSumPast)) {
            message.dollarDelinquentInstallmentsSumPast = globalThis.Number(object.dollarDelinquentInstallmentsSumPast);
        }
        if (isSet(object.delinquentInstallmentsCount)) {
            message.delinquentInstallmentsCount = globalThis.Number(object.delinquentInstallmentsCount);
        }
        if (isSet(object.dollarsPaidSumPast)) {
            message.dollarsPaidSumPast = globalThis.Number(object.dollarsPaidSumPast);
        }
        if (isSet(object.updatedAtMs)) {
            message.updatedAtMs = globalThis.String(object.updatedAtMs);
        }
        if (isSet(object.lendingRiskLevel)) {
            message.lendingRiskLevel = globalThis.String(object.lendingRiskLevel);
        }
        if (isSet(object.paidLoanCountLevel)) {
            message.paidLoanCountLevel = globalThis.Number(object.paidLoanCountLevel);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.loansTakenCountPast !== undefined && message.loansTakenCountPast !== 0) {
            obj.loansTakenCountPast = Math.round(message.loansTakenCountPast);
        }
        if (message.loansFullyRepaidCountPast !== undefined && message.loansFullyRepaidCountPast !== 0) {
            obj.loansFullyRepaidCountPast = Math.round(message.loansFullyRepaidCountPast);
        }
        if (message.loansOutstandingCount !== undefined && message.loansOutstandingCount !== 0) {
            obj.loansOutstandingCount = Math.round(message.loansOutstandingCount);
        }
        if (message.loansDelinquentCount !== undefined && message.loansDelinquentCount !== 0) {
            obj.loansDelinquentCount = Math.round(message.loansDelinquentCount);
        }
        if (message.loansFullyRepaidPct !== undefined && message.loansFullyRepaidPct !== 0) {
            obj.loansFullyRepaidPct = message.loansFullyRepaidPct;
        }
        if (message.loansDelinquentPct !== undefined && message.loansDelinquentPct !== 0) {
            obj.loansDelinquentPct = message.loansDelinquentPct;
        }
        if (message.loanSizeAvgPast !== undefined && message.loanSizeAvgPast !== 0) {
            obj.loanSizeAvgPast = message.loanSizeAvgPast;
        }
        if (message.installmentsCountPast !== undefined && message.installmentsCountPast !== 0) {
            obj.installmentsCountPast = Math.round(message.installmentsCountPast);
        }
        if (message.outstandingInstallmentsCountPast !== undefined &&
            message.outstandingInstallmentsCountPast !== 0) {
            obj.outstandingInstallmentsCountPast = Math.round(message.outstandingInstallmentsCountPast);
        }
        if (message.outstandingPrincipalSum !== undefined && message.outstandingPrincipalSum !== 0) {
            obj.outstandingPrincipalSum = message.outstandingPrincipalSum;
        }
        if (message.installmentsDueCountPast !== undefined && message.installmentsDueCountPast !== 0) {
            obj.installmentsDueCountPast = Math.round(message.installmentsDueCountPast);
        }
        if (message.dollarDelinquentInstallmentsSumPast !== undefined &&
            message.dollarDelinquentInstallmentsSumPast !== 0) {
            obj.dollarDelinquentInstallmentsSumPast = message.dollarDelinquentInstallmentsSumPast;
        }
        if (message.delinquentInstallmentsCount !== undefined && message.delinquentInstallmentsCount !== 0) {
            obj.delinquentInstallmentsCount = Math.round(message.delinquentInstallmentsCount);
        }
        if (message.dollarsPaidSumPast !== undefined && message.dollarsPaidSumPast !== 0) {
            obj.dollarsPaidSumPast = message.dollarsPaidSumPast;
        }
        if (message.updatedAtMs !== undefined && message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.lendingRiskLevel !== undefined && message.lendingRiskLevel !== '') {
            obj.lendingRiskLevel = message.lendingRiskLevel;
        }
        if (message.paidLoanCountLevel !== undefined && message.paidLoanCountLevel !== 0) {
            obj.paidLoanCountLevel = Math.round(message.paidLoanCountLevel);
        }
        return obj;
    },
    create(base) {
        return exports.LendingFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLendingFeatures();
        message.loansTakenCountPast = object.loansTakenCountPast ?? 0;
        message.loansFullyRepaidCountPast = object.loansFullyRepaidCountPast ?? 0;
        message.loansOutstandingCount = object.loansOutstandingCount ?? 0;
        message.loansDelinquentCount = object.loansDelinquentCount ?? 0;
        message.loansFullyRepaidPct = object.loansFullyRepaidPct ?? 0;
        message.loansDelinquentPct = object.loansDelinquentPct ?? 0;
        message.loanSizeAvgPast = object.loanSizeAvgPast ?? 0;
        message.installmentsCountPast = object.installmentsCountPast ?? 0;
        message.outstandingInstallmentsCountPast = object.outstandingInstallmentsCountPast ?? 0;
        message.outstandingPrincipalSum = object.outstandingPrincipalSum ?? 0;
        message.installmentsDueCountPast = object.installmentsDueCountPast ?? 0;
        message.dollarDelinquentInstallmentsSumPast = object.dollarDelinquentInstallmentsSumPast ?? 0;
        message.delinquentInstallmentsCount = object.delinquentInstallmentsCount ?? 0;
        message.dollarsPaidSumPast = object.dollarsPaidSumPast ?? 0;
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.lendingRiskLevel = object.lendingRiskLevel ?? '';
        message.paidLoanCountLevel = object.paidLoanCountLevel ?? 0;
        return message;
    },
};
function createBaseZipcodeFeatures() {
    return {
        zipcode: '',
        medianIncome: 0,
        giniIndex: 0,
        unemploymentRate: 0,
        nearestZipcode: '',
        nearestZipcodeMedianIncome: 0,
        nearestZipcodeGiniIndex: 0,
        nearestZipcodeUnemploymentRate: 0,
    };
}
exports.ZipcodeFeatures = {
    fromJSON(object) {
        const message = {
            zipcode: isSet(object.zipcode) ? globalThis.String(object.zipcode) : '',
        };
        if (isSet(object.medianIncome)) {
            message.medianIncome = globalThis.Number(object.medianIncome);
        }
        if (isSet(object.giniIndex)) {
            message.giniIndex = globalThis.Number(object.giniIndex);
        }
        if (isSet(object.unemploymentRate)) {
            message.unemploymentRate = globalThis.Number(object.unemploymentRate);
        }
        if (isSet(object.nearestZipcode)) {
            message.nearestZipcode = globalThis.String(object.nearestZipcode);
        }
        if (isSet(object.nearestZipcodeMedianIncome)) {
            message.nearestZipcodeMedianIncome = globalThis.Number(object.nearestZipcodeMedianIncome);
        }
        if (isSet(object.nearestZipcodeGiniIndex)) {
            message.nearestZipcodeGiniIndex = globalThis.Number(object.nearestZipcodeGiniIndex);
        }
        if (isSet(object.nearestZipcodeUnemploymentRate)) {
            message.nearestZipcodeUnemploymentRate = globalThis.Number(object.nearestZipcodeUnemploymentRate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.zipcode !== '') {
            obj.zipcode = message.zipcode;
        }
        if (message.medianIncome !== undefined && message.medianIncome !== 0) {
            obj.medianIncome = message.medianIncome;
        }
        if (message.giniIndex !== undefined && message.giniIndex !== 0) {
            obj.giniIndex = message.giniIndex;
        }
        if (message.unemploymentRate !== undefined && message.unemploymentRate !== 0) {
            obj.unemploymentRate = message.unemploymentRate;
        }
        if (message.nearestZipcode !== undefined && message.nearestZipcode !== '') {
            obj.nearestZipcode = message.nearestZipcode;
        }
        if (message.nearestZipcodeMedianIncome !== undefined && message.nearestZipcodeMedianIncome !== 0) {
            obj.nearestZipcodeMedianIncome = message.nearestZipcodeMedianIncome;
        }
        if (message.nearestZipcodeGiniIndex !== undefined && message.nearestZipcodeGiniIndex !== 0) {
            obj.nearestZipcodeGiniIndex = message.nearestZipcodeGiniIndex;
        }
        if (message.nearestZipcodeUnemploymentRate !== undefined &&
            message.nearestZipcodeUnemploymentRate !== 0) {
            obj.nearestZipcodeUnemploymentRate = message.nearestZipcodeUnemploymentRate;
        }
        return obj;
    },
    create(base) {
        return exports.ZipcodeFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseZipcodeFeatures();
        message.zipcode = object.zipcode ?? '';
        message.medianIncome = object.medianIncome ?? 0;
        message.giniIndex = object.giniIndex ?? 0;
        message.unemploymentRate = object.unemploymentRate ?? 0;
        message.nearestZipcode = object.nearestZipcode ?? '';
        message.nearestZipcodeMedianIncome = object.nearestZipcodeMedianIncome ?? 0;
        message.nearestZipcodeGiniIndex = object.nearestZipcodeGiniIndex ?? 0;
        message.nearestZipcodeUnemploymentRate = object.nearestZipcodeUnemploymentRate ?? 0;
        return message;
    },
};
function createBaseUserGraphFeatures() {
    return { userId: '', createdAtMs: '0', updatedAtMs: '0' };
}
exports.UserGraphFeatures = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.UserGraphFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserGraphFeatures();
        message.userId = object.userId ?? '';
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function createBaseIdentityCheckFeatures() {
    return { userId: '', identityCheck: undefined };
}
exports.IdentityCheckFeatures = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.identityCheck)) {
            message.identityCheck = identity_check_1.IdentityCheck.fromJSON(object.identityCheck);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.identityCheck !== undefined) {
            obj.identityCheck = identity_check_1.IdentityCheck.toJSON(message.identityCheck);
        }
        return obj;
    },
    create(base) {
        return exports.IdentityCheckFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIdentityCheckFeatures();
        message.userId = object.userId ?? '';
        message.identityCheck = (object.identityCheck !== undefined && object.identityCheck !== null)
            ? identity_check_1.IdentityCheck.fromPartial(object.identityCheck)
            : undefined;
        return message;
    },
};
function createBaseReferralFeatures() {
    return { familyMembersRewardedCount: '0', lastFamilyMemberRewardedAtMs: undefined };
}
exports.ReferralFeatures = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.familyMembersRewardedCount)) {
            message.familyMembersRewardedCount = globalThis.String(object.familyMembersRewardedCount);
        }
        if (isSet(object.lastFamilyMemberRewardedAtMs)) {
            message.lastFamilyMemberRewardedAtMs = globalThis.String(object.lastFamilyMemberRewardedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.familyMembersRewardedCount !== undefined && message.familyMembersRewardedCount !== '0') {
            obj.familyMembersRewardedCount = message.familyMembersRewardedCount;
        }
        if (message.lastFamilyMemberRewardedAtMs !== undefined) {
            obj.lastFamilyMemberRewardedAtMs = message.lastFamilyMemberRewardedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.ReferralFeatures.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralFeatures();
        message.familyMembersRewardedCount = object.familyMembersRewardedCount ?? '0';
        message.lastFamilyMemberRewardedAtMs = object.lastFamilyMemberRewardedAtMs ?? undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=user-features.js.map